import React from 'react';
import { Avatar, Badge, Box, Card, CardContent, Grid, IconButton, Typography, styled } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { ReactFCC } from '../../interface/react';
import { UserProfile } from '../../interface/user';
import styles from './UserGridItem.module.scss';

interface UserGridItemProps {
	user: UserProfile;
}

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		backgroundColor: '#44b700',
		color: '#44b700',
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		'&::after': {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			borderRadius: '50%',
			animation: 'ripple 1.2s infinite ease-in-out',
			border: '1px solid currentColor',
			content: '""',
		},
	},
	'@keyframes ripple': {
		'0%': {
			transform: 'scale(.8)',
			opacity: 1,
		},
		'100%': {
			transform: 'scale(2.4)',
			opacity: 0,
		},
	},
}));

const UserGridItem: ReactFCC<UserGridItemProps> = ({ user }) => {
	return (
		<Grid
			key={user.id}
			item
			sx={{
				width: {
					xs: '50%',
					sm: '33%',
					md: '25%',
					lg: '20%',
				},
				p: {
					xs: 0,
					sm: 1,
				},
				mb: 2,
			}}
			className={styles.UserGridItem}
		>
			<Card
				elevation={0}
				sx={{
					borderRadius: 5,
					textAlign: 'center',
					// backgroundColor: 'rgb(31 41 55 / 1)',
					// color: '#fff',
					transition: 'all 0.2s ease-in-out',
					':hover': {
						boxShadow: 6,
						cursor: 'pointer',
						transform: 'translateY(-2px)',
					},
					border: `1px solid ${user.isLiked ? '#e91e63' : '#eee'}`,
				}}
			>
				<CardContent sx={{ p: 0, pb: 0 }}>
					<Box sx={{ position: 'relative' }}>
						<StyledBadge
							overlap="circular"
							anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
							variant="dot"
							invisible={user.isOnline !== true}
						>
							<Avatar
								sx={{ width: '100%', height: '100%', mx: 'auto', borderRadius: 5 }}
								variant="square"
								src={`${user.image}??ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=320&h=360&q=80`}
							/>
						</StyledBadge>
						{/* <Box
							sx={{
								position: 'absolute',
								bottom: 0,
								left: 0,
								width: '100%',
								height: '100%',
								borderRadius: 5,
								background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 60%, rgba(0,0,0,0.6) 100%)',
								transition: 'all 0.2s ease-in-out',
								color: '#fff',
								opacity: 0,
								':hover': {
									opacity: 1,
								},
							}}
						>
							<Box
								sx={{
									position: 'absolute',
									bottom: 0,
									left: 0,
									width: '100%',
									p: 1.5,
								}}
							>
								<Typography gutterBottom variant="h6" sx={{ fontWeight: 600, m: 0 }} component="div">
									{user.name}
								</Typography>
								<Typography gutterBottom variant="subtitle1" sx={{ fontSize: 12, m: 0 }} component="div">
									{user.age}, {user.location}
								</Typography>
								<IconButton aria-label="like">
									<FavoriteIcon sx={{ color: '#e91e63' }} />
									<FavoriteBorderIcon sx={{ color: '#f50057' }} />
								</IconButton>
							</Box>
						</Box> */}
					</Box>
					<Box sx={{ p: 1.5 }}>
						<IconButton aria-label="like">
							{user.isLiked ? (
								<FavoriteIcon sx={{ color: '#e91e63' }} />
							) : (
								<FavoriteBorderIcon sx={{ color: '#f50057' }} />
							)}
						</IconButton>
						<Typography gutterBottom variant="h6" sx={{ fontWeight: 600, m: 0 }} component="div">
							{user.name}
						</Typography>
						<Typography gutterBottom variant="subtitle1" sx={{ fontSize: 12, m: 0 }} component="div">
							{user.age}, {user.location}
						</Typography>
						<Typography gutterBottom variant="h6" sx={{ fontSize: 12, mb: -1 }} component="div">
							<span className={styles.limitText}>
								{user.status}
								{user.status}
								{user.status}
								{user.status}
							</span>
						</Typography>
					</Box>
				</CardContent>
			</Card>
		</Grid>
	);
};

export default UserGridItem;
